import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "duplicate" }
const _hoisted_2 = { class: "owner" }
const _hoisted_3 = { class: "owner-data" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "email" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Avatar, {
        width: "5.6rem",
        height: "5.6rem",
        url: $options.avatar_url,
        name: $options.name
      }, null, 8 /* PROPS */, ["url", "name"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($options.name), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, _toDisplayString($options.email), 1 /* TEXT */)
      ])
    ]),
    ($options.self_prompt)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "description" }, " You are trying to copy your own prompt. ", -1 /* HOISTED */)),
          _createElementVNode("div", {
            disabled: $props.copying,
            class: "actions"
          }, [
            _createVNode(_component_Button, {
              class: "done-btn",
              primary: "",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => [
                ($props.copying)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      inline: "",
                      mini: "",
                      color: "var(--base-white)"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Close")
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ], 8 /* PROPS */, _hoisted_6)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "description" }, " Shared a prompt with you. ", -1 /* HOISTED */)),
          _createElementVNode("div", {
            disabled: $props.copying,
            class: "actions"
          }, [
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Cancel ")
              ])),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Button, {
              class: "done-btn",
              primary: "",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('duplicate')))
            }, {
              default: _withCtx(() => [
                ($props.copying)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      inline: "",
                      mini: "",
                      color: "var(--base-white)"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Duplicate")
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ], 8 /* PROPS */, _hoisted_7)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}